module.exports = __webpack_public_path__ + "static/media/designation.d5dd3867.svg";